import { render, staticRenderFns } from "./CenterScore.vue?vue&type=template&id=306e86ed&scoped=true"
import script from "./CenterScore.vue?vue&type=script&lang=js"
export * from "./CenterScore.vue?vue&type=script&lang=js"
import style0 from "./CenterScore.vue?vue&type=style&index=0&id=306e86ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306e86ed",
  null
  
)

export default component.exports